import { route } from "../../../../src/routes/helpers";
import { CompensationPages } from "../../../../src/constants/AppConstants";
import config from "../../../../src/config";

export default route(CompensationPages.DETAILS, {
    onEnter() {
        window.location = config.get('compensationHelpUrl');
    }
});
